<template>
  <form @submit.prevent="handleSubmit" id="material_create_form" enctype="multipart/form-data">
    <div class="mb-4">
      <label class="form-label form-label-thin">Material Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="name" name="name" v-model="form.name"
        placeholder="Material Name" />
    </div>

    <!-- Code -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Code <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="code" name="code" v-model="form.code"
        placeholder="Material Code" />
    </div>

    <!-- Serial Number -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Serial Number <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="serial_number" name="serial_number"
        v-model="form.serial_number" placeholder="Serial Number" />
    </div>

    <!-- Category Dropdown -->
    <div class="mb-4">
      <MultiSelect v-model="form.material_category_id" :multiple="false" label="Material Category"
        :options="materialCategories" option-label="name" option-value="id" />
    </div>

    <!-- Manufacturer -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Manufacturer <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="manufacturer" name="manufacturer"
        v-model="form.manufacturer" placeholder="Manufacturer" />
    </div>

    <div class="mb-4">
      <label class="form-label form-label-thin">Unit <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="unit" name="unit" v-model="form.unit"
        placeholder="Unit" />
    </div>

    <div class="mb-4">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label form-label-thin mb-0">
          Asset <span class="text-danger">*</span>
        </label>

        <button type="button" class="btn btn-sm btn-link text-primary text-decoration-none p-0"
          @click="openCreateAssetModal">
          <i class="fa fa-plus-circle me-1"></i>
          Add Asset
        </button>
      </div>

      <MultiSelect v-model="form.asset_ids" :options="assets" placeholder="Select assets…" />
      <FormModal ref="createAssetModal" title="Create New Asset" id="create_asset_form_modal">
        <CreateAsset ref="CreateAssetForm" @created="onAssetCreated" @close="closeCreateAssetModal" />
      </FormModal>
    </div>
    <div class="mb-4">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label form-label-thin mb-0">
          Vendors
        </label>

        <button type="button" class="btn btn-sm btn-link text-primary text-decoration-none p-0"
          @click="openCreateVendorModal">
          <i class="fa fa-plus-circle me-1"></i>
          Add Vendor
        </button>
      </div>

      <MultiSelect v-model="form.vendor_ids" :options="vendors" placeholder="Select vendors…" />
    </div>

    <!-- Create Vendor Modal -->
    <FormModal ref="createVendorModal" title="Create New Vendor" id="create_vendor_form_modal">
      <CreateVendor ref="createVendorForm" @created="onVendorCreated" @close="closeCreateVendorModal" />
    </FormModal>
    <!-- Description -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Description (If Any)</label>
      <textarea class="form-control form-control-thin" id="description" name="description" v-model="form.description"
        placeholder="Material Description" rows="3"></textarea>
    </div>

    <!-- Photo -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Photo</label>
      <input type="file" class="form-control form-control-thin" id="photo" name="photo" @change="handlePhotoChange"
        accept="image/*" />
      <div v-if="form.photo_preview" class="mt-2">
        <img :src="form.photo_preview" alt="Preview" style="max-width: 200px; max-height: 200px;" />
      </div>
    </div>

    <!-- File -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Attachment File</label>
      <input type="file" class="form-control form-control-thin" id="file" name="file"
        @change="form.file = $event.target.files[0]" />
      <small class="text-muted">Max size: 20MB</small>
    </div>
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-sm btn-outline-secondary" @click="close">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary py-1 px-2 text-light hover-white btn-sm form-submit-btn"
        :disabled="submitting">
        <i class="fa fa-save"></i> {{ submitting ? 'Creating...' : 'Create Material' }}
      </button>
    </div>
  </form>

  <!-- Modal -->
</template>
<script>
import { form_api_submit } from '@/utils/FormSubmit'
import MultiSelect from '@/components/MultiSelect.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateAsset from '@/views/Asset/CreateAsset.vue'
import CreateVendor from '@/views/Vendor/CreateVendor.vue'
export default {
  name: 'CreateMaterial',

  components: {
    MultiSelect,
    FormModal,
    CreateAsset,
    CreateVendor,
  },

  emits: ['created', 'close'],

  data() {
    return {
      form: {
        name: '',
        code: '',
        serial_number: '',
        material_category_id: '',
        manufacturer: '',
        unit: '',
        description: '',
        photo: null,
        photo_preview: null,
        file: null,
        asset_ids: [],
        vendor_ids: [],
      },

      submitting: false,
      materialCategories: [],
      assets: [],
      vendors: [],
    }
  },

  mounted() {
    this.getMaterialCategories()
    this.getAssets()
    this.getVendors()
  },

  methods: {
    handlePhotoChange(event) {
      const file = event.target.files[0]
      this.form.photo = file

      if (file) {
        const reader = new FileReader()

        reader.onload = (e) => {
          this.form.photo_preview = e.target.result
        }

        reader.readAsDataURL(file)
      }
    },

    async handleSubmit() {
      this.submitting = true

      try {
        const fd = new FormData()
        const scalars = [
          'name',
          'code',
          'serial_number',
          'material_category_id',
          'manufacturer',
          'unit',
          'description'
        ]

        scalars.forEach(key => {
          if (this.form[key] !== null && this.form[key] !== '') {
            fd.append(key, this.form[key])
          }
        })
        if (this.form.photo) {
          fd.append('photo', this.form.photo)
        }

        if (this.form.file) {
          fd.append('file', this.form.file)
        }
        this.form.asset_ids.forEach(id => {
          fd.append('asset_ids[]', id)
        })

        this.form.vendor_ids.forEach(id => {
          fd.append('vendor_ids[]', id)
        })

        const result = await form_api_submit({
          url: 'materials/create',
          method: 'POST',
          data: fd,
          curr_form_id: '#material_create_form'
        })

        if (result.success) {

          this.$emit('created')
          this.$emit('close')

        }

      } finally {
        this.submitting = false
      }
    },
    async getAssets() {
      try {
        const result = await form_api_submit({
          url: 'asset/dropdown',
          method: 'GET',
          show_success_toast: false,
          show_error_toast: false,
        })

        if (result?.success) {
          this.assets = result.data || []
        }
      } catch (error) {
        console.error('Failed to load assets', error)
      }
    },

    async getVendors() {
      try {
        const result = await form_api_submit({
          url: 'vendor/get-vendors',
          method: 'GET',
          show_success_toast: false,
          show_error_toast: false,
        })

        if (result?.success) {
          this.vendors = (result.data || []).map(vendor => ({
            id: vendor.id,
            name: vendor.first_name,
            external_id: vendor.external_id,
          }))
        }
      } catch (error) {
        console.error('Failed to load vendors', error)
      }
    },

    async getMaterialCategories() {
      try {
        const result = await form_api_submit({
          url: 'material-categories/dropdown',
          method: 'GET',
          show_success_toast: false,
          show_error_toast: false,
        })

        if (result?.success) {
          this.materialCategories = result.data || []
        }
      } catch (error) {
        console.error('Failed to load material categories', error)
      }
    },
    openCreateAssetModal() {
      this.$refs.createAssetModal.showModal()
    },

    closeCreateAssetModal() {
      this.$refs.createAssetModal.closeModal()
    },

    async onAssetCreated(assetData) {
      await this.getAssets()

      this.closeCreateAssetModal()

      if (
        assetData &&
        assetData.asset &&
        assetData.asset.external_id
      ) {
        const newAsset = this.assets.find(
          a => a.external_id === assetData.asset.external_id
        )

        if (newAsset) {
          // Since MultiSelect is multiple
          if (!Array.isArray(this.form.asset_ids)) {
            this.form.asset_ids = []
          }

          this.form.asset_ids.push(newAsset.id)
        }
      }
    },
    openCreateVendorModal() {
  this.$refs.createVendorModal.showModal()
},

closeCreateVendorModal() {
  this.$refs.createVendorModal.closeModal()
},

async onVendorCreated(vendorData) {
  await this.getVendors()

  this.closeCreateVendorModal()

  if (
    vendorData &&
    vendorData.vendor &&
    vendorData.vendor.external_id
  ) {
    const newVendor = this.vendors.find(
      v => v.external_id === vendorData.vendor.external_id
    )

    if (newVendor) {
      if (!Array.isArray(this.form.vendor_ids)) {
        this.form.vendor_ids = []
      }

      this.form.vendor_ids.push(newVendor.id)
    }
  }
},
    close() {
      this.$emit('close')
    },

    resetForm() {
      this.form = {
        name: '',
        code: '',
        serial_number: '',
        material_category_id: '',
        manufacturer: '',
        unit: '',
        description: '',
        photo: null,
        photo_preview: null,
        file: null,
        asset_ids: [],
        vendor_ids: [],
      }
    }
  }
}
</script>
<style scoped>
.modal-footer {
  padding: 12px 0 0 0;
  border-top: none;
  gap: 8px;
}
</style>